import React, { useState } from 'react';
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from '@rocco/components/accordion';

interface RefineExpanderProps extends React.PropsWithChildren {
    title: string;
    /** Staged-value summary shown muted in the collapsed header. */
    summary?: string;
}

/**
 * An in-place expander for controls that need room (range sliders). Uses
 * +/− glyphs — chevrons are reserved for drill-in navigation — and keeps
 * the staged values legible in the collapsed header.
 */
export const RefineExpander = (props: RefineExpanderProps) => {
    const { title, summary, children } = props;
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Accordion
            type="single"
            collapsible
            onValueChange={(value) => setIsOpen(!!value)}
        >
            {/* lightBorder matches the drill-in rows' divider; the default
                variant's 30%-black border reads as emphasis it hasn't earned. */}
            <AccordionItem value={title} variant="lightBorder">
                <AccordionTrigger
                    variant="narrow"
                    icon="plus"
                    openIcon="minus"
                    isOpen={isOpen}
                    className="min-h-11"
                >
                    <div className="flex w-full items-center justify-between gap-2 pr-2">
                        <span className="text-sm font-medium">{title}</span>
                        {!isOpen && summary && (
                            <span className="truncate text-sm font-normal text-gray-400">
                                {summary}
                            </span>
                        )}
                    </div>
                </AccordionTrigger>
                <AccordionContent>
                    <div className="grid pt-0 pb-2">{children}</div>
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
};
